import React, { useState } from 'react';
import InfoToggle from '../Global/InfoToggle';

const OrderLinksDropdown = ({ orderIds, orderExternalIds, isEditing = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!orderIds || !orderExternalIds || orderIds.length === 0 || isEditing) {
    return <span>-</span>;
  }

  return (
    <div className="position-relative">
      <InfoToggle
        label={`${orderExternalIds.length} pedido(s)`}
        openState={isOpen}
        handleToggle={() => setIsOpen(!isOpen)}
        showChevron={true}
        color="#007bff"
      />
      
      {isOpen && (
        <div className="position-absolute bg-white shadow-sm border rounded p-2 mt-1 z-index-dropdown" 
             style={{ zIndex: 1000, minWidth: '200px' }}>
          <ul className="list-unstyled m-0">
            {orderIds.map((id, index) => (
              <li key={id} className="mb-1">
                <a 
                  href={`/orders/${id}`} 
                  className="text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {orderExternalIds[index] || `Pedido #${id}`}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default OrderLinksDropdown;